/**
 * Get user photo URL directly from Telegram or MAX messenger
 * without saving to database
 */
export const getUserPhotoUrl = (): string | null => {
  if (typeof window === 'undefined') return null;

  try {
    // Try Telegram first
    if (window.Telegram?.WebApp?.initData) {
      const initData = new URLSearchParams(window.Telegram.WebApp.initData);
      const userJson = initData.get('user');
      if (userJson) {
        const user = JSON.parse(userJson);
        if (user.photo_url) {
          return user.photo_url;
        }
      }
    }

    // Try MAX
    if (window.WebApp?.initData) {
      const initData = new URLSearchParams(window.WebApp.initData);
      const userJson = initData.get('user');
      if (userJson) {
        const user = JSON.parse(userJson);
        if (user.photo_url) {
          return user.photo_url;
        }
      }
    }
  } catch (error) {
    console.error('Error getting user photo URL:', error);
  }

  return null;
};
